// Configurazione SEO centralizzata

export const SEO_CONFIG = {
  // Configurazione di base
  baseUrl: 'https://loverlist.com',
  siteName: 'Loverlist.com',
  defaultLanguage: 'it',
  defaultLocale: 'it_IT',
  
  // Immagini di default
  defaultOgImage: 'https://loverlist.com/media/assets/Home Hero_Tavola disegno 1.png',
  defaultTwitterImage: 'https://loverlist.com/media/assets/Home Hero_Tavola disegno 1.png',
  
  // Meta tags di default
  defaultMeta: {
    robots: 'index, follow',
    language: 'Italian',
    'revisit-after': '7 days',
    author: 'Loverlist.com'
  },
  
  // Configurazione Open Graph
  defaultOg: {
    type: 'website',
    site_name: 'Loverlist.com',
    locale: 'it_IT'
  },
  
  // Configurazione Twitter
  defaultTwitter: {
    card: 'summary_large_image',
    site: '@loverlist'
  },
  
  // Configurazione structured data
  structuredData: {
    organization: {
      name: 'Loverlist.com',
      url: 'https://loverlist.com',
      logo: 'https://loverlist.com/media/assets/logo.png',
      sameAs: [
        'https://www.facebook.com/loverlist.shopping',
        'https://instagram.com/loverlist.shopping'
      ],
      contactPoint: {
        contactType: 'customer service',
        email: 'info@loverlist.com'
      }
    },
    website: {
      name: 'Loverlist.com',
      description: 'Comparatore di prezzi per trovare le migliori offerte online',
      url: 'https://loverlist.com',
      potentialAction: {
        type: 'SearchAction',
        target: {
          type: 'EntryPoint',
          urlTemplate: 'https://loverlist.com/search?q={search_term_string}'
        },
        'query-input': 'required name=search_term_string'
      }
    }
  }
};

// Funzioni helper per SEO
export const generateSEOMetadata = (pageData) => {
  const {
    title,
    description,
    keywords = '',
    canonical = '',
    ogImage = SEO_CONFIG.defaultOgImage,
    ogType = 'website',
    twitterCard = 'summary_large_image',
    structuredData = null
  } = pageData;

  return {
    title: title ? `${title} | ${SEO_CONFIG.siteName}` : SEO_CONFIG.siteName,
    description,
    keywords,
    canonical: canonical || `${SEO_CONFIG.baseUrl}${window.location.pathname}`,
    ogImage,
    ogType,
    twitterCard,
    structuredData
  };
};

export const generateProductSEOMetadata = (product, sellers = []) => {
  if (!product) return null;

  return generateSEOMetadata({
    title: product.title,
    description: `Scopri ${product.title} su Loverlist. Confronta prezzi e trova le migliori offerte da ${sellers.length} venditori.`,
    keywords: `${product.title}, ${product.brand || ''}, ${product.category_title || ''}, prezzi, offerte, confronta, acquista online`,
    canonical: `${SEO_CONFIG.baseUrl}/products/${product.id}`,
    ogImage: product.main_image_url,
    ogType: 'product',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: product.title,
      description: product.description?.replace(/<[^>]+>/g, '').substring(0, 500),
      image: product.main_image_url,
      brand: {
        '@type': 'Brand',
        name: product.brand || 'Unknown'
      },
      category: product.category_title,
      mpn: product.sku,
      gtin: product.ean,
      offers: sellers.map(seller => ({
        '@type': 'Offer',
        price: seller.price,
        priceCurrency: 'EUR',
        availability: seller.available ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
        seller: {
          '@type': 'Organization',
          name: seller.store_name
        },
        url: seller.product_url
      }))
    }
  });
};

export const generateCategorySEOMetadata = (category, products = []) => {
  if (!category) return null;

  return generateSEOMetadata({
    title: category.category_title,
    description: `Scopri ${category.category_title} su Loverlist. Confronta prezzi e trova le migliori offerte da ${products.length} prodotti disponibili.`,
    keywords: `${category.category_title}, prezzi, offerte, confronta, acquista online`,
    canonical: `${SEO_CONFIG.baseUrl}/categories/${category.handle}`,
    ogType: 'website',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: category.category_title,
      description: `Scopri ${category.category_title} su Loverlist. Confronta prezzi e trova le migliori offerte.`,
      url: `${SEO_CONFIG.baseUrl}/categories/${category.handle}`,
      mainEntity: {
        '@type': 'ItemList',
        numberOfItems: products.length,
        itemListElement: products.slice(0, 10).map((product, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@type': 'Product',
            name: product.title,
            url: `${SEO_CONFIG.baseUrl}/products/${product.id}`,
            image: product.main_image_url
          }
        }))
      }
    }
  });
};

// Funzioni helper aggiuntive
export const generateBreadcrumbStructuredData = (breadcrumbs) => {
  if (!breadcrumbs || breadcrumbs.length === 0) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.name,
      item: crumb.url
    }))
  };
}; 